import React from 'react';

/**
 * Inline content loader used on profile tabs (messages, comments, subscription, etc.):
 * spinning circle + loading label, matching the inbox table-load state.
 */
export const LearnerInlineContentLoader: React.FC<{
  message: string;
  className?: string;
}> = ({ message, className = '' }) => (
  <div className={`flex items-center justify-center py-8 ${className}`}>
    <div
      className="h-8 w-8 animate-spin rounded-full border-b-2 border-purple-500 dark:border-purple-400"
      aria-hidden
    />
    <span className="ms-3 text-gray-600 dark:text-gray-300">{message}</span>
  </div>
);
